import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import style from "./AboutMe.module.css";
// import picture from "../../../assets/3.jpg";
import picture from '../../../assets/aboutProfile.jpg'

const AboutMe = () => {
  return (
    <div className={style.aboutMe}>
      <div className={style.title__content}>
        <h5>WHO AM I</h5>
        <h1>
          <span className={style.about}>ABOUT</span>{" "}
          <span className={style.me}>ME</span>
        </h1>
      </div>
      <div className={style.aboutMe__container}>
        <Container>
          <Row>
            <Col xs={12} sm={12} md={5}>
              <div className={style.my__img}>
                <img
                  className={`${style.picture} img-fluid`}
                  src={picture}
                  alt="img"
                />
              </div>
            </Col>
            <Col xs={12} sm={12} md={7}>
              <div className={style.aboutMe__content}>
                <p>
                  I believe I'm a Quick learner and an Innovative web developer.
                  I'm very affection to learn programming. Coding is a
                  significant part of my life. I always want to learn new
                  technology to grow my skills and utilize my knowledge in the
                  development community.
                </p>
                <div className={style.skills}>
                  <h3>MY SKILLS</h3>
                  <h6>
                    <span>Expertise :</span> HTML, CSS, Bootstrap, Javascript
                    (ES6), React js, React-Bootstrap, React-router-dom, Axios.
                  </h6>
                  <h6>
                    <span>Comfortable :</span> Node js, Express js, MongoDb,
                    Firebase, API, JSON.
                  </h6>
                  <h6>
                    <span>Familiar :</span> Material-ui, Redux, Next js, React
                    Native, React Hook form, React-Query, Stripe payment, dot
                    env, Tailwind CSS, SASS.{" "}
                  </h6>
                  <h6>
                    <span>Tools :</span> Git, Github, VS Code, Chrome dev tool,
                    Netlify, Heroku, NPM, Yarn.
                  </h6>
                </div>
                {/* <button className={style.resume}>Download Resume</button> */}
                <a
                  className={style.resume}
                  target="_blank."
                  href="https://drive.google.com/u/0/uc?id=1ypb8q4ZNUqPpJlHsHoyQ_0b7wa2Gc7mt&export=download"
                >
                  Download Resume
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default AboutMe;
